import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  WelcomerState,
  clearAddon,
  clearGroupAddon,
  removeAddon,
  removeGroupAddon,
  setAddon,
  setAllPrices,
  setCompanyOffers,
  setCurrency,
  setCurrencyId,
  setFixedOffer,
  setGroupAddon,
  setIsCompanyFromUser,
  setLimit,
  setLimitId,
  setOffer,
  setOfferTotalPrice,
  updateAddon,
  updateGroupAddon,
  updateWelcomerDatesPrices,
} from '../../../store/welcomerSlice'
import { WelcomerOffers, currencySymbol, WelcomersDatePrices, georgianFormatter } from '../../../domain/types'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import LeftThreeDot from '../../../assets/v2/JSX/LeftThreeDot'
import RightThreeDot from '../../../assets/v2/JSX/RightThreeDot'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import Dropdown from '../../../components/v2/Dropdown'
import dayjs from 'dayjs'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { toast } from 'react-toastify'
import CubesIcon from '../../../assets/v2/JSX/CubesIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import CompanySelect from '../../../components/v2/CompanySelect'
import CountBar from '../../../components/v2/CountBar'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import CustomLink from '../../../components/v2/CustomLink'
import { Container } from '../../../assets/styles/GlobalStyle'
import BaseModal from '../../../components/v2/modals/BaseModal'
import Loader from '../../../components/Loader'
import { isEqual } from 'lodash'
import RightLineArrowIcon from '../../../assets/v2/JSX/RightLineArrowIcon'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const WelcomerOffer = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  const [openAddonAccordion, setOpenAddonAccordion] = useState<boolean>(true)
  //
  const [selectedCoverageId, setSelectedCoverageId] = useState<number | undefined>(0)
  //
  const [updatedDatesPrices, setUpdatedDatesPrices] = useState<WelcomersDatePrices[]>([
    { age: 0, date: null, priceId: 0, premium: 0, welcomerAgeGroupId: 0, welcomerDayGroupId: 0 },
  ])
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-best-offer')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  //
  const isDataValid = (data: any) => {
    if (!Array.isArray(data)) {
      return false
    }

    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (
        item.age === null ||
        item.age === 0 ||
        item.date === null ||
        item.date.length !== 14 ||
        Number(item.age) < 0
      ) {
        return false
      }
    }

    return true
  }
  //
  const [getLeftCompanies, { data: leftCompanies, isLoading: isLeftCompanyLoading, reset }] =
    api.useWelcomerLeftCompaniesLastStepMutation()
  //
  //
  const { data: WelcomerCurrencies, isLoading: isWelcomerCurrenciesLoading } =
    api.useGetWelcomerCurrencyListQuery(undefined)
  //
  const { data: WelcomerLimits, isLoading: isWelcomerLimitsLoading } = api.useGetWelcomerLimitListQuery(undefined)
  //
  const [welcomerOffers, { isLoading: isWelcomerOffersLoading, data: welcomerBestOffers }] =
    api.useWelcomerBestOfferMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.welcomersDate &&
      filter.welcomersDate !== undefined &&
      filter.welcomersDate.length >= 1 &&
      isDataValid(filter.welcomersDate) &&
      filter.currency &&
      filter.singleDates?.start &&
      filter?.singleDates?.end
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: 'step-three',
            productCategory: filter.productCategory,
            startDate: filter.singleDates?.start as string,
            endDate: filter.singleDates?.end as string,
            currency: filter.currency,
            limit: filter.limit as number,
            // @ts-ignore
            ages: filter.welcomersDate.map((t) => (t.month === null ? t.age : 0)),
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (ChooseMethod)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.welcomersDate,
    filter?.insuranceDays,
    getLeftCompanies,
  ])
  //
  //
  useEffect(() => {
    if (
      leftCompanies &&
      leftCompanies.count >= 1 &&
      welcomerOffers &&
      filter?.singleDates?.start &&
      filter?.singleDates?.end &&
      filter?.currencyId &&
      filter?.limitId &&
      filter?.welcomersDate
    ) {
      const getBestOffer = async () => {
        try {
          //
          await welcomerOffers({
            days: filter?.insuranceDays,
            currencyId: filter?.currencyId,
            limitId: filter?.limitId,
            packageIds: leftCompanies?.packageData?.map((x) => x.id),
            // @ts-ignore
            ages: filter.welcomersDate.map((t) => (t.month === null ? t.age : 0)),
          }).unwrap()
          //
          reset()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით...')
          }
        }
      }
      //
      if (leftCompanies && leftCompanies.count >= 1) {
        getBestOffer()
      }
    }

    return () => {}
  }, [
    reset,
    filter.chooseMethod,
    filter.productCategory,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.welcomersDate,
    filter.currencyId,
    filter.limitId,
    filter?.insuranceDays,
    welcomerOffers,
    leftCompanies,
  ])
  //
  useEffect(() => {
    if (welcomerBestOffers && leftCompanies && leftCompanies.count >= 1) {
      if (filter?.chooseMethod === 'frani-choose' && filter?.fixedOffer === false) {
        let bestOffer = welcomerBestOffers && welcomerBestOffers.find((x) => x.isBestOption === true)
        let unitedPrices = bestOffer && bestOffer?.prices.map((x) => x.premium)

        let updatedWelcomersDate: WelcomersDatePrices[] | undefined = filter?.welcomersDate?.map((x) => {
          return {
            age: x.age,
            date: x.date,
            priceId:
              bestOffer?.prices?.find((b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age)
                ?.id || 0,
            premium:
              bestOffer?.prices?.find((b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age)
                ?.premium || 0,
            welcomerAgeGroupId:
              bestOffer?.prices?.find((b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age)
                ?.welcomerAgeGroupId || 0,
            welcomerDayGroupId:
              bestOffer?.prices?.find((b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age)
                ?.welcomerDayGroupId || 0,
          }
        })

        setUpdatedDatesPrices(updatedWelcomersDate as any)

        if (!isEqual(unitedPrices, filter?.allPrices)) {
          dispatch(setAllPrices(unitedPrices))
        }

        if (!isEqual(welcomerBestOffers, filter?.companyOffers)) {
          dispatch(setCompanyOffers(welcomerBestOffers))
        }

        if (!isEqual(bestOffer, filter?.offer)) {
          dispatch(setOffer(bestOffer?.prices[0]))
        }
      }

      if (filter?.chooseMethod === 'my-choose' && filter?.fixedOffer === false) {
        const LeftCompanyIds = leftCompanies?.uniqueCompanies?.map((x) => x.id)

        const selectedCompaniesIds: number[] = LeftCompanyIds?.filter((id) =>
          filter?.selectedCompaniesIds?.includes(id as never),
        )

        const companyOffers = welcomerBestOffers.filter((offer) =>
          selectedCompaniesIds?.some(
            (companyId) =>
              offer?.prices?.map((x) => x.welcomerPackage?.mainPackage?.product?.companyId)[0] ===
              (companyId as number),
          ),
        )

        if (!isEqual(companyOffers, filter?.companyOffers)) {
          dispatch(setCompanyOffers(companyOffers))
        }

        if (filter?.IsCompanyFromUser === false) {
          let bestOffer = companyOffers && companyOffers.find((x) => x.isBestOption === true)

          let unitedPrices = bestOffer && bestOffer?.prices.map((x) => x.premium)

          let updatedWelcomersDate: { age: number; date: string | null; priceId: number }[] | undefined =
            filter?.welcomersDate?.map((x) => {
              return {
                age: x.age,
                date: x.date,
                priceId:
                  bestOffer?.prices?.find(
                    (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                  )?.id || 0,
                premium:
                  bestOffer?.prices?.find(
                    (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                  )?.premium || 0,
                welcomerAgeGroupId:
                  bestOffer?.prices?.find(
                    (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                  )?.welcomerAgeGroupId || 0,
                welcomerDayGroupId:
                  bestOffer?.prices?.find(
                    (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                  )?.welcomerDayGroupId || 0,
              }
            })

          setUpdatedDatesPrices(updatedWelcomersDate as any)

          if (!isEqual(unitedPrices, filter?.allPrices)) {
            dispatch(setAllPrices(unitedPrices))
          }

          if (!isEqual(bestOffer, filter?.offer)) {
            dispatch(setOffer(bestOffer?.prices[0]))
          }
        }
      }
    }

    if (leftCompanies?.count === 0) {
      if (!isEqual([], filter?.companyOffers)) {
        dispatch(setCompanyOffers([]))
      }
      //
      if (!isEqual(undefined, filter?.offer)) {
        dispatch(setOffer(undefined))
      }
    }
  }, [
    welcomerBestOffers,
    dispatch,
    filter?.chooseMethod,
    leftCompanies,
    filter?.companyOffers,
    filter?.offer,
    filter?.selectedCompaniesIds,
    filter?.IsCompanyFromUser,
    filter?.allPrices,
    filter?.fixedOffer,
    filter?.welcomersDate,
    filter?.welcomersDatePrices,
  ])
  // ###############
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })
  //
  //
  // attached Addons Calculate the total price
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + parseInt(item.addon.premium, 10) * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0
  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) => accumulator + item.addon.premium * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  // set total price with addon price for next pages
  useEffect(() => {
    //
    const fullPrice =
      filter?.allPrices && filter.insuranceDays
        ? filter?.allPrices?.map((x) => x).reduce((sum, premium) => sum + Number(premium), 0) * filter.insuranceDays +
          allAddonPrice
        : 0
    //
    if (filter?.allPrices && fullPrice) {
      dispatch(setOfferTotalPrice(fullPrice))
    }
    //
    return () => {}
  }, [allAddonPrice, filter?.allPrices, dispatch, filter.insuranceDays])
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  const parsedWordingFileUrl = filter?.offer?.welcomerPackage?.mainPackage?.product?.wordingFileUrl?.includes(
    'translations',
  )
    ? JSON.parse(filter?.offer?.welcomerPackage?.mainPackage?.product?.wordingFileUrl)
    : ''
  //

  const MainLoading =
    isWelcomerOffersLoading ||
    isWelcomerLimitsLoading ||
    isWelcomerCurrenciesLoading ||
    isLeftCompanyLoading ||
    isPageInfoLoading

  return MainLoading ? (
    <Loader text={t('chooseBestOffer')} />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />
        <WelcomerProgressbar stepName={stepName} />

        <Price $pricePosition={scrollPosition}>
          <LeftThreeDot />
          <div>{filter?.offer === undefined ? 0 : georgianFormatter.format(Number(filter?.offerTotalPrice))} ₾</div>
          <RightThreeDot />
        </Price>

        {filter.companyOffers && filter?.companyOffers?.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '30px',
            }}
            text={t('offerNotFoundChangeSetting')}
          />
        )}
        <Block>
          <OfferTitle
            style={{
              userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
            }}
          >
            {t('see')}{' '}
            <b>{filter.offer?.welcomerPackage?.mainPackage?.product?.company?.translations?.[lang]?.title}</b>
            {t('seeCompanyOffer')}
          </OfferTitle>
          <OfferDescription
            style={{
              userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
            }}
          >
            {t('youCanChooseOtherCompany')}
          </OfferDescription>

          <CompanySelect
            style={{
              userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
            }}
            closeMenuOnSelect={true}
            value={filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id}
            onChange={(data) => {
              if (data.value) {
                let offer = filter.companyOffers?.filter((offer) =>
                  offer.prices.some((price) => price.welcomerPackage.mainPackage.product.company.id === data.value),
                )[0]

                let updatedWelcomersDate: WelcomersDatePrices[] | undefined = filter?.welcomersDate?.map((x) => {
                  return {
                    age: x.age,
                    date: x.date,
                    priceId:
                      offer?.prices?.find(
                        (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                      )?.id || 0,
                    premium:
                      offer?.prices?.find(
                        (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                      )?.premium || 0,
                    welcomerAgeGroupId:
                      offer?.prices?.find(
                        (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                      )?.welcomerAgeGroupId || 0,
                    welcomerDayGroupId:
                      offer?.prices?.find(
                        (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                      )?.welcomerDayGroupId || 0,
                  }
                })

                return [
                  dispatch(
                    setOffer(
                      filter.companyOffers?.filter((offer) =>
                        offer.prices.some(
                          (price) => price.welcomerPackage.mainPackage.product.company.id === data.value,
                        ),
                      )[0].prices[0],
                    ),
                  ),
                  dispatch(
                    setAllPrices(
                      filter.companyOffers
                        ?.filter((offer) =>
                          offer.prices.some(
                            (price) => price.welcomerPackage.mainPackage.product.company.id === data.value,
                          ),
                        )[0]
                        .prices.map((x) => x.premium),
                    ),
                  ),
                  setUpdatedDatesPrices(updatedWelcomersDate as any),
                  dispatch(setIsCompanyFromUser(false)),
                  dispatch(clearAddon([])),
                  dispatch(clearGroupAddon([])),
                  dispatch(setFixedOffer(false)),
                ]
              }
            }}
            isMulti={false}
            maxSelectLenght={3}
            maxSelectText={`${t('companyCompare')}`}
            placeholder={t('selectCompanies')}
            showInnerPrice={true}
            showOptionCheckmark={true}
            options={filter.companyOffers?.map((o: WelcomerOffers) => ({
              value: o?.prices[0].welcomerPackage?.mainPackage?.product?.company?.id,
              label: o?.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.brandName?.[lang]?.title,
              imgUrl: o?.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.logo,
              price: o?.prices
                ?.map((x) => x.premium * (filter?.insuranceDays || 1))
                .reduce((sum, premium) => sum + Number(premium), 0),
            }))}
          />

          <br />

          <AddonsTitle>{t('youCanChange')}</AddonsTitle>

          <DropdownWrapper>
            <Dropdown
              title={`${t('currency')}`}
              value={filter.currency}
              options={WelcomerCurrencies?.filter((x) => x.isActive === true)?.map((x) => ({
                value: x.currencyCode.toLowerCase(),
                label: x.currencyCode?.toUpperCase(),
              }))}
              placeholder={``}
              onChange={(obj) => {
                let currencyId = WelcomerCurrencies?.filter((x) => x.isActive === true)?.filter(
                  (x) => x.currencyCode.toLowerCase() === obj.value.toLowerCase(),
                )
                currencyId && dispatch(setCurrencyId(currencyId[0].id))

                if (filter.chooseMethod === 'frani-choose') {
                  return [
                    dispatch(setCurrency(obj.value)),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                    // dispatch(setOffer(undefined)),
                    dispatch(setFixedOffer(false)),
                    dispatch(setIsCompanyFromUser(false)),
                  ]
                } else {
                  return [
                    dispatch(setCurrency(obj.value)),
                    dispatch(setIsCompanyFromUser(false)),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                  ]
                }
              }}
            />

            <Dropdown
              title={`${t('limit')}`}
              value={filter.limit}
              options={WelcomerLimits?.filter((x) => x.isActive === true).map((x) => ({
                value: x.value,
                label:
                  x.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                  ` ${currencySymbol(filter.currency || 'gel')}`,
              }))}
              placeholder={``}
              onChange={(obj) => {
                let limitId = WelcomerLimits?.filter((x) => x.isActive === true)?.filter(
                  (x) => x.value === Number(obj.value),
                )
                limitId && dispatch(setLimitId(limitId[0].id))

                if (filter.chooseMethod === 'frani-choose') {
                  return [
                    dispatch(setLimit(Number(obj.value))),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                    dispatch(setOffer(undefined)),
                    dispatch(setFixedOffer(false)),
                    dispatch(setIsCompanyFromUser(false)),
                  ]
                } else {
                  return [
                    dispatch(setLimit(Number(obj.value))),
                    dispatch(setIsCompanyFromUser(false)),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                  ]
                }
              }}
            />
          </DropdownWrapper>

          <HR />

          {/* addons section */}
          {filter?.offer &&
          (filter?.offer?.welcomerPackage?.attachedAddons === undefined ||
            filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos === undefined) ? null : (
            <div
              style={{
                userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
                pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
                opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
              }}
            >
              {(filter?.offer &&
                filter?.offer?.welcomerPackage?.attachedAddons &&
                filter?.offer?.welcomerPackage?.attachedAddons?.length >= 1) ||
              (filter?.offer &&
                filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos &&
                filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos?.length >= 1) ? (
                <AddonsBlock
                  style={{
                    opacity:
                      filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id !== undefined ? 'unset' : '0.7',
                    pointerEvents:
                      filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id !== undefined ? 'unset' : 'none',
                    userSelect:
                      filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id === undefined ? 'unset' : 'none',
                  }}
                >
                  <AddonAccordion>
                    <AddonHead onClick={() => setOpenAddonAccordion(!openAddonAccordion)}>
                      <span>{t('useCoverage')}</span>
                      <RightArrowStyle
                        style={{
                          transform: openAddonAccordion ? 'rotate(-90deg)' : 'rotate(90deg)',
                        }}
                      />
                    </AddonHead>

                    {openAddonAccordion ? (
                      <AddonsContent>
                        {filter.offer &&
                        filter?.offer?.welcomerPackage &&
                        filter?.offer?.welcomerPackage?.attachedAddons &&
                        filter?.offer?.welcomerPackage?.attachedAddons.length >= 1 ? (
                          <>
                            {filter?.offer?.welcomerPackage?.attachedAddons &&
                              filter?.offer?.welcomerPackage?.attachedAddons
                                .filter((x) => x && x.addonId)
                                ?.map((atAddon, atAddonIndex) => {
                                  //
                                  const attachedAddonsInitialCount =
                                    filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id !== undefined &&
                                    filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId)
                                  //
                                  return (
                                    <StandartAddon key={atAddonIndex}>
                                      <AddonLeftDiv>
                                        <AddonImg src={atAddon?.addon?.image} alt={`addon-img-${atAddonIndex}`} />
                                        <StandartAddonLeftSide>
                                          <span>{atAddon.addon?.translations?.[lang]?.title}</span>
                                          <span>
                                            {t('price')}: {atAddon.premium} ₾
                                            {atAddon.paymentType === 'ONCE' ? (
                                              <> / {t('coverageCost')}</>
                                            ) : (
                                              <> / {t('coverageCostByPerson')}</>
                                            )}
                                          </span>
                                          {filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId) ? (
                                            <span className="offer-addon-description">
                                              {atAddon.translations?.[lang]?.description}
                                            </span>
                                          ) : null}
                                        </StandartAddonLeftSide>
                                      </AddonLeftDiv>

                                      <CountBar
                                        // this ts ignore not important
                                        // @ts-ignore
                                        initialCount={attachedAddonsInitialCount?.count ?? 0}
                                        step={1}
                                        maxCount={filter.welcomersDate?.length}
                                        plusOnClick={(value) => {
                                          // create and set new addon
                                          if (
                                            filter.attachedAddons &&
                                            (filter.attachedAddons.length <= 0 ||
                                              filter.attachedAddons.find((x) => x.addon.addonId !== atAddon.addonId)) &&
                                            value === 1
                                          ) {
                                            // create new addon
                                            dispatch(setAddon({ addon: atAddon, count: value }))
                                          }
                                          //
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1 && value > 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                        }}
                                        //
                                        //
                                        minusOnClick={(value) => {
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                          // remove addon by id
                                          if (
                                            filter.attachedAddons &&
                                            filter.attachedAddons.length >= 1 &&
                                            value === 0
                                          ) {
                                            //  remove addon by id
                                            dispatch(removeAddon(atAddon.addonId))
                                          }
                                        }}
                                      />
                                    </StandartAddon>
                                  )
                                })}
                          </>
                        ) : null}

                        {filter?.offer &&
                        filter?.offer?.welcomerPackage &&
                        filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos &&
                        filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos.length >= 1 ? (
                          <>
                            {filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos &&
                              filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos
                                ?.filter((x) => x && x.id)
                                ?.map((groupAddon, groupAddonIndex) => {
                                  //
                                  const groupAttachedAddonsInitialCount =
                                    filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id !== undefined &&
                                    filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id)
                                  //
                                  return (
                                    <GroupAddon key={groupAddonIndex}>
                                      <StandartAddon>
                                        <AddonLeftDiv>
                                          <CubesIconStyle />
                                          <StandartAddonLeftSide>
                                            <span>{groupAddon.translations?.[lang]?.title}</span>
                                            <span>
                                              {t('price')}: {groupAddon.premium} ₾
                                              {groupAddon.paymentType === 'ONCE' ? (
                                                <> / {t('coverageCost')}</>
                                              ) : (
                                                <> / {t('coverageCostByPerson')}</>
                                              )}
                                            </span>
                                          </StandartAddonLeftSide>
                                        </AddonLeftDiv>
                                        <CountBar
                                          // this ts ignore not important
                                          // @ts-ignore
                                          initialCount={groupAttachedAddonsInitialCount?.count ?? 0}
                                          step={1}
                                          maxCount={filter.welcomersDate?.length}
                                          plusOnClick={(value) => {
                                            //
                                            // create and set new addon
                                            if (
                                              filter.groupedAttachedAddons &&
                                              (filter.groupedAttachedAddons.length <= 0 ||
                                                filter.groupedAttachedAddons.find(
                                                  (x) => x.addon.id !== groupAddon.id,
                                                )) &&
                                              value === 1
                                            ) {
                                              // create new addon
                                              dispatch(setGroupAddon({ addon: groupAddon, count: value }))
                                            }
                                            //
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value > 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            //
                                          }}
                                          minusOnClick={(value) => {
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            // remove addon by id
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value === 0
                                            ) {
                                              //  remove addon by id
                                              dispatch(removeGroupAddon(groupAddon.id))
                                            }
                                          }}
                                        />
                                      </StandartAddon>

                                      {groupAddon?.addons?.map((innerGroupAddon, innerGroupAddonIndex) => (
                                        <GroupAddonDescription key={innerGroupAddonIndex}>
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <DoubleRightIcon />
                                            <span>{innerGroupAddon?.addon?.translations?.[lang]?.title}</span>
                                          </div>
                                          {filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id) ? (
                                            <span className="offer-addon-description">
                                              {innerGroupAddon?.description}
                                            </span>
                                          ) : null}
                                        </GroupAddonDescription>
                                      ))}
                                    </GroupAddon>
                                  )
                                })}
                          </>
                        ) : null}
                      </AddonsContent>
                    ) : null}
                  </AddonAccordion>
                </AddonsBlock>
              ) : null}
              {(filter?.offer &&
                filter?.offer?.welcomerPackage?.attachedAddons &&
                filter?.offer?.welcomerPackage?.attachedAddons?.length >= 1) ||
              (filter?.offer &&
                filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos &&
                filter?.offer?.welcomerPackage?.groupedAttachedAddonInfos?.length >= 1) ? (
                <HR />
              ) : null}
            </div>
          )}

          {/* offer texts */}
          <OfferTextBox>
            <OffetTextLeftSide>{t('policyType')}</OffetTextLeftSide>
            <OffetTextRightSide>{lang === 'ge' ? 'ერთჯერადი' : 'Single'}</OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {filter?.insuranceDays} {t('day')}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('startDate')}</OffetTextLeftSide>
            <OffetTextRightSide>{dayjs(filter?.singleDates?.start).format('D MMMM YYYY')}</OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('endDate')}</OffetTextLeftSide>
            <OffetTextRightSide>{dayjs(filter?.singleDates?.end).format('D MMMM YYYY')}</OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('travelArea')}</OffetTextLeftSide>
            <OffetTextRightSide>{lang === 'ge' ? 'საქართველო' : lang === 'en' ? 'Georgia' : ''}</OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('numberOfTravellers')} </OffetTextLeftSide>
            <OffetTextRightSide>
              {filter?.welcomersDate?.length} {t('traveler')}
            </OffetTextRightSide>
          </OfferTextBox>

          <HR />

          <OfferTextBox>
            <OffetTextLeftSide>{t('limit')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {filter.limit?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {currencySymbol(filter.currency)}
            </OffetTextRightSide>
          </OfferTextBox>

          <HR />

          <ATagStyle
            style={{
              userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
              opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
            }}
            href={
              filter?.offer?.welcomerPackage?.mainPackage?.wordingFiles?.translations?.[lang]?.url ??
              parsedWordingFileUrl?.translations?.[lang]?.url
            }
            target="_blank"
          >
            <div>{t('policyTerms')}</div>
            <div>
              <RightLineArrowIcon />
            </div>
          </ATagStyle>
        </Block>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choose') {
                return [
                  navigate('/welcomer-choose-method'),
                  // dispatch(setOffer(undefined)),
                  dispatch(clearAddon([])),
                  dispatch(clearGroupAddon([])),
                ]
              }
              //
              if (filter.chooseMethod === 'my-choose') {
                return [navigate('/welcomer-offers')]
              }
              //
              return [navigate('/welcomer-choose-method'), dispatch(clearAddon([])), dispatch(clearGroupAddon([]))]
              //
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.companyOffers && filter.companyOffers.length >= 1 && filter.offer !== undefined ? false : true
            }
            onClick={() => {
              if (filter?.IsCompanyFromUser === false) {
                dispatch(updateWelcomerDatesPrices(updatedDatesPrices))
              }

              return [navigate('/welcomer-who-do-you-insure'), dispatch(setFixedOffer(true))]
            }}
          />
        </Buttons>
      </Content>

      <Container
        style={{
          userSelect: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
          pointerEvents: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : 'none',
          opacity: filter.companyOffers && filter.companyOffers.length >= 1 ? 'unset' : '0.6',
        }}
      >
        <CoveredWrapper>
          <CoveredTitle>{t('whatIsCovered')}</CoveredTitle>
          <CoveredContent>
            {filter?.offer &&
              filter.offer?.welcomerPackage?.mainPackage?.welcomerEnabledRisks?.map((item, index) => (
                <CoveredBlock key={index}>
                  <CoveredImage src={`${item?.welcomerRisk?.icon}`} alt={`${item?.welcomerRisk?.riskName}`} />
                  <CoveredName>{item?.welcomerRisk?.translations?.[lang]?.riskName}</CoveredName>
                  <CoveredDescription>{item?.translations?.[lang]?.riskDescription}</CoveredDescription>

                  <CustomLink
                    onClick={() => setSelectedCoverageId(item.id)}
                    text={t('inDetails')}
                    rightLineIcon={false}
                  />

                  <VerticalBorder />
                </CoveredBlock>
              ))}
          </CoveredContent>
        </CoveredWrapper>

        <HR />

        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('notCovered')}</span>
            </MessageHead>
            {filter?.offer &&
              filter?.offer?.welcomerPackage?.mainPackage?.insuranceExceptions?.map((item, index) => (
                <MessageText key={index}>
                  <DoubleRightIcon /> <span>{item.translations?.[lang]?.title}</span>
                </MessageText>
              ))}
          </MessageContent>
        </MessageBox>
      </Container>

      <BaseModal
        isOpen={
          filter?.offer &&
          filter?.offer?.welcomerPackage.mainPackage?.welcomerEnabledRisks?.find((x) => x.id === selectedCoverageId)
            ? true
            : false
        }
        onClose={() => setSelectedCoverageId(0)}
      >
        {filter?.offer &&
          filter?.offer?.welcomerPackage?.mainPackage?.welcomerEnabledRisks?.find((x) => x.id === selectedCoverageId)
            ?.translations?.[lang]?.riskDescription}
      </BaseModal>
      {scrollPosition <= 0 && <BackgroundIcon />}
    </Wrapper>
  )
}

// styles

const AddonImg = styled.img`
  width: 40px;
  margin-right: 25px;
  margin-top: 7px;
  ${Responsive.mobile} {
    display: none;
  }
`
const AddonLeftDiv = styled.div`
  display: flex;
  align-items: flex-start;
`
const RightArrowStyle = styled(RightArrow)`
  width: 20px;
  margin-left: auto;
  transform: scale(1.1);
`
const CubesIconStyle = styled(CubesIcon)`
  width: 40px;
  height: 40px;
  margin-right: 25px;
  ${Responsive.mobile} {
    display: none;
  }
`
const AddonHead = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  span {
    font-size: 18px;
    color: ${Colors.primaryBlack};
  }
`
const AddonAccordion = styled.div`
  /*  */
`
const AddonsBlock = styled.div`
  /*  */
`
const GroupAddonDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 63px;
  svg {
    width: 11px;
    margin-right: 9px;
    margin-top: 1px;
  }
  .offer-addon-description {
    font-size: 14px;
    color: ${Colors.primaryBlack};
    margin-top: 10px;
    color: ${Colors.nevadaGrey};
  }
  ${Responsive.mobile} {
    margin-left: 0px;
  }
`
const StandartAddonLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  text-align: left;
  span {
    :not(:first-child) {
      color: ${Colors.nevadaGrey};
    }
  }
  .offer-addon-description {
    margin-right: 20px;
    margin-top: 10px;
  }
`
const StandartAddon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }
`
const GroupAddon = styled.div`
  margin-top: 22px;
  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }
  ${StandartAddon} {
    margin-top: 0px;
    border-bottom: unset;
    padding-bottom: 0px;
  }
`
const AddonsContent = styled.div`
  /*  */
`
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  /*  */
  &:last-child {
    margin-bottom: 0px;
  }
  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }
  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }
  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }
    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;
    /* message text span */
    span {
      margin-left: 15px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div`
  :first-child {
    border-top: 1px solid ${Colors.secondaryGrey};
    margin-top: 80px;
  }
  padding-top: 30px;
  ${Responsive.tablet} {
    max-width: 700px;
    margin: 0 auto;
  }
`
const CoveredDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  font-weight: normal;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CoveredName = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  font-weight: normal;
  margin-bottom: 8px;
  text-align: center;
`
const VerticalBorder = styled.div`
  background-color: ${Colors.secondaryGrey};
  width: 1px;
  height: 100%;
  position: absolute;
  left: -50px;
  display: none;
  ${Responsive.mobile} {
    display: block;
    transform: rotate(0deg);
    width: 100%;
    height: 1px;
    left: 0px;
    top: -13%;
  }
`
const CoveredImage = styled.img`
  min-height: 40px;
  height: 40px;
  width: 48px;
  margin-bottom: 20px;
`
const CoveredTitle = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 60px;
`
const CoveredBlock = styled.div`
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  a {
    span {
      text-decoration: underline;
    }
  }
  &:first-child {
    ${VerticalBorder} {
      display: none;
    }
  }
  ${Responsive.desktop} {
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  /* responsive */
  ${Responsive.laptop} {
    width: 300px;
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.tablet} {
    width: 300px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.mobile} {
    width: 320px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
`
const CoveredContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 100px;
  ${Responsive.mobile} {
    gap: 48px;
    justify-content: space-around;
    flex-direction: column;
  }
`
const CoveredWrapper = styled.div`
  position: relative;
  z-index: 2;
  margin-block: 80px;
  ${Responsive.mobile} {
    margin-bottom: 40px;
    margin-top: 50px;
  }
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 10px;
  color: ${Colors.primaryBlack};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  div {
    line-height: 18px;
    &:last-child {
      margin-left: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 16px;
        height: 10px;
      }
    }
  }
  /*  */
  &:hover {
    color: ${Colors.primaryBlack};
    div {
      svg {
        color: ${Colors.primaryRed};
      }
    }
  }
`
const OfferTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`
const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
`
const HR = styled.hr`
  margin-block: 24px;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  ${Responsive.laptop} {
    gap: 2rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 2rem 2rem;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem 2rem;
  }
`
const OfferDescription = styled.h6`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
`
const OfferTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const AddonsTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const Price = styled.div<{ $pricePosition: number }>`
  position: sticky;
  top: 100px;
  right: 0;
  width: fit-content;
  margin: ${({ $pricePosition }) => ($pricePosition >= 170 ? '0 0 0 auto' : '0 auto')};
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  user-select: none;
  pointer-events: none;

  /* text */
  div {
    width: fit-content;
    height: 64px;
    background-color: ${Colors.primaryRed};
    border-radius: 40px;
    color: ${Colors.white};
    font-size: 20px;
    padding-inline: 40px;
    margin-inline: 10px;
    display: grid;
    place-items: center;
    box-shadow: 0 4px 35px 0 rgba(254, 95, 85, 0.32);
  }

  svg {
    height: 64px;
  }

  /* Responsive */
  ${Responsive.laptop} {
    top: 120px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 120 ? '0 0 0 auto' : '0 auto')};
    margin-top: 32px;

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      height: 40px;
    }
  }

  ${Responsive.tablet} {
    top: 100px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 160 ? 'none' : 'unset')};
      height: 40px;
    }
  }

  ${Responsive.mobile} {
    top: 80px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 100 ? 'none' : 'unset')};
      height: 40px;
    }
  }
`

const Block = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  margin-block: 32px 48px;
  border-radius: 8px;

  ${Responsive.mobile} {
    margin-block: 33px;
    padding: 20px;
    width: 100%;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Content = styled.div`
  width: 100%;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`

export default WelcomerOffer
